import { useTheme } from "@/context/useTheme";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Switch } from "antd";

const ThemeSwitcher = () => {
  const { current, toggleTheme } = useTheme();

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={current === "dark"}
        onChange={toggleTheme}
        size="small"
        className="theme-switch"
        checkedChildren={<MoonOutlined className="text-xs" />}
        unCheckedChildren={<SunOutlined className="text-xs" />}
      />
    </div>
  );
};

export default ThemeSwitcher;
